"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _defaultHttpAgent, _defaultHttpsAgent;
Object.defineProperty(exports, "__esModule", { value: true });
const agentkeepalive_1 = __importDefault(require("agentkeepalive"));
class Agent {
    constructor(agentOpts) {
        _defaultHttpAgent.set(this, void 0);
        _defaultHttpsAgent.set(this, void 0);
        __classPrivateFieldSet(this, _defaultHttpAgent, new agentkeepalive_1.default(agentOpts));
        __classPrivateFieldSet(this, _defaultHttpsAgent, new agentkeepalive_1.default.HttpsAgent(agentOpts));
    }
    getAgent(url) {
        if (url.startsWith('https:')) {
            return __classPrivateFieldGet(this, _defaultHttpsAgent);
        }
        else if (url.startsWith('http:')) {
            return __classPrivateFieldGet(this, _defaultHttpAgent);
        }
        else {
            throw new Error('Unknown protocol');
        }
    }
}
exports.default = Agent;
_defaultHttpAgent = new WeakMap(), _defaultHttpsAgent = new WeakMap();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZmlsZTovLy9ob21lL2phcm1vL2dpdC90dXJpc3QtY2xvdWQvZmV0Y2gvc3JjL2FnZW50LXdyYXBwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUVBLG9FQUF1QztBQUd2QyxNQUFxQixLQUFLO0lBSXpCLFlBQVksU0FBdUI7UUFIbkMsb0NBQThCO1FBQzlCLHFDQUFnQztRQUcvQix1QkFBQSxJQUFJLHFCQUFxQixJQUFJLHdCQUFTLENBQUMsU0FBUyxDQUFDLEVBQUM7UUFFbEQsdUJBQUEsSUFBSSxzQkFBc0IsSUFBSSx3QkFBUyxDQUFDLFVBQVUsQ0FBQyxTQUFTLENBQUMsRUFBQztJQUMvRCxDQUFDO0lBRUQsUUFBUSxDQUFDLEdBQVc7UUFDbkIsSUFBSSxHQUFHLENBQUMsVUFBVSxDQUFDLFFBQVEsQ0FBQyxFQUFFO1lBQzdCLHdEQUErQjtTQUMvQjthQUFNLElBQUksR0FBRyxDQUFDLFVBQVUsQ0FBQyxPQUFPLENBQUMsRUFBRTtZQUNuQyx1REFBOEI7U0FDOUI7YUFBTTtZQUNOLE1BQU0sSUFBSSxLQUFLLENBQUMsa0JBQWtCLENBQUMsQ0FBQztTQUNwQztJQUNGLENBQUM7Q0FDRDtBQW5CRCx3QkFtQkMifQ==